<template>
  <div class="flex flex-col items-center py-4">
    <div class="flex flex-row sm:space-x-4 4k:space-x-8 items-center">
      <button class="experience-button" role="button" aria-label="Next" tabindex="0"
        @click="onChangeCard(false)">
        <IconChevronL />
      </button>
      <div v-for="(item, index) in jobsList" :key="index" v-show="index === currentIndex">
        <ExperienceCard
          :title="item.title"
          :date="item.date"
          :description="item.description"
          :listLang="item.listLang"
          :pic="item.pic"
        />
      </div>
      <button class="experience-button" role="button" aria-label="Next" tabindex="0"
        @click="onChangeCard(true)">
        <IconChevronR />
      </button>
    </div>
    <div class="flex flex-row my-4 space-x-4">
      <div v-for="(item, index) in jobsList" :key="index"
        role="button" aria-label="Next" tabindex="0" @keyup.enter="onChangeCard(true)"
        :class="{
          'bg-winter-pink shadow-xl opacity-50': index !== currentIndex,
          'bg-summer-red shadow-inner': index === currentIndex,
        }"
        class="w-4 h-4 4k:w-10 4k:h-10 4k:mt-2 rounded-full cursor-pointer focus:outline-none"
        @click="onSelectIndex(index)">
      </div>
    </div>
  </div>
</template>

<script>
import ExperienceCard from '../components/ExperienceCard.vue';

export default {
  components: {
    ExperienceCard,
  },
  data() {
    return {
      jobsList: [
        {
          title: 'Taaxii - Inpunto',
          description: this.$options.filters.lang('jobs', 'experience').taaxii,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/inpunto.jpg?alt=media&token=095a51c5-65c4-46e7-bde2-be3d024c618f',
          date: '08-2020 - 02-2021',
          listLang: ['Java + Spring + Gradle', 'GWT', 'Docker', 'AWS', 'Liquibase', 'Ibatis', 'mySQL', 'mySQL Workbench', 'VueJS', 'Axios', 'Vuex', 'TailwindCSS', 'Firebase Hosting']
        },
        {
          title: 'Mayorista Acero Blanco',
          description: this.$options.filters.lang('jobs', 'experience').aceroBlanco,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/aceroblanco.jpg?alt=media&token=470f6888-fd68-4bda-b324-a9e641c6f3f0',
          date: '08-2020',
          listLang: ['Angular 10', 'Semantic UI', 'Redux']
        },
        {
          title: 'TaQadam',
          description: this.$options.filters.lang('jobs', 'experience').taqadam,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/taqadam.jpg?alt=media&token=23eb8a6d-9ed2-4be0-bd51-fb0b9d456354',
          date: '08-2020 - 11-2020',
          listLang: ['Django', 'Django REST', 'HTML5', 'CSS3', 'MaterializeCSS', 'JS', 'JQuery']
        },
        {
          title: 'Tools SDX Space',
          description: this.$options.filters.lang('jobs', 'experience').sdxSpace,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/space.jpg?alt=media&token=2203e817-2803-4518-a480-fd91516b8471',
          date: '06-2020',
          listLang: ['Angular 9', 'Angular material']
        },
        {
          title: 'Desaffuture',
          description: this.$options.filters.lang('jobs', 'experience').desaffuture,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/desaffuture.jpg?alt=media&token=21faa802-046e-4d27-965b-2c7001338be2',
          date: '01-2020 - 10-2020 ~ Standby',
          listLang: ['Angular 8 | 9', 'Angular material', 'Redux', 'Firebase Auth + Hosting', 'Django', 'Django REST']
        },
        {
          title: 'Welo',
          description: this.$options.filters.lang('jobs', 'experience').welo,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/welo.jpg?alt=media&token=08c83a64-917d-4511-8b29-e44c20933684',
          date: '09-2019 - 07-2020',
          listLang: ['Angular 8 | 9', 'Angular material', 'Tachyons', 'Redux', 'GraphQL', 'Video.js', 'hls.js']
        },
        {
          title: 'Nutrirnos',
          description: this.$options.filters.lang('jobs', 'experience').nutrirnos,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/nutrirnos.jpg?alt=media&token=e02c2135-bcf4-4c6d-8abe-9e42f9a9a101',
          date: '01-2019 - 05-2020 ~ Standby',
          listLang: ['Angular 7 | 8 | 9', 'Firebase Auth + Firestore', 'Firebase Hosting', 'Angular material', 'Bulma', 'Highcharts']
        },
        {
          title: 'AbraKdabra',
          description: this.$options.filters.lang('jobs', 'experience').abrakdabra,
          pic: 'https://firebasestorage.googleapis.com/v0/b/portfolio-kaysoohyun.appspot.com/o/abrakdabra.jpg?alt=media&token=4f8e509f-2ad2-41c9-bed5-f28183c3ff2a',
          date: '10-2018 - 11-2018',
          listLang: ['HTML5', 'CSS', 'JS', 'W3.CSS', 'Inkscape', 'Leaflet']
        },
      ],
      currentIndex: 0
    };
  },
  methods: {
    onChangeCard(dir) {
      if (dir) {
        this.currentIndex += 1;
      } else {
        this.currentIndex -= 1;
      }

      if (this.currentIndex >= this.jobsList.length && dir) {
        this.currentIndex = 0;
      } else if (this.currentIndex < 0 && !dir) {
        this.currentIndex = this.jobsList.length - 1;
      }
    },
    onSelectIndex(index) {
      this.currentIndex = index;
    }
  },
}
</script>